/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { apiFetch } from '../../../apiClient';
import { apiMap } from '../../../config/constants';
import * as FileUploadInfoAction from '../state/action';
import BasePage from '../../../shared/BasePage';
import FileUploadInfo from '../components/FileUploadInfo';
import { Grid } from 'react-bootstrap';

import '../style/fileUploadInfo.css'
import { isEmptyObject } from '../../../utils/index';
/* eslint-disable array-callback-return */
class FileUploadInfoContainer extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount(){
        super.componentWillMount();
        this.loadContentMessage();
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
    }

    loadContentMessage = () => {
        apiFetch(apiMap.fileUploadI18n)().then( i18n => {
            if(i18n) {
                this.props.fileUploadInfoHandle({i18n});
            }
        }).catch(error => {});
    };

    render() {
        const { i18n, applicationInfo } = this.props;

        return (applicationInfo && applicationInfo.sections && !isEmptyObject(applicationInfo.sections) && i18n) ? (
            <Grid className="dynamic-form ao-form pq-form file-upload-form">
                <div className="file-upload-info-container">
                   <FileUploadInfo
                    {...this.props}
                    />
                </div>
            </Grid>
        ) : null
    }
}

FileUploadInfoContainer.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = (state) => ({
    applicationInfo: state.app.applicationInfo,
    sectionInfo: state.app.sectionInfo,
    businessInfo: state.app.businessInfo,
    i18n: state.fileUploadInfo.i18n,
    flieUploadInfo: state.fileUploadInfo,
    selectedLanguage: state.app.selectedLanguage,
    form_base_content: state.app.i18n.form_base_content,
    isShowOtherFile: state.fileUpload.isShowOtherFile,
    appMessages:state.app.i18n,
    isShowFileloading: state.fileUploadInfo.isShowFileloading,
    pageTitle: state.app.i18n.pageTitle
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(FileUploadInfoAction, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FileUploadInfoContainer);


// WEBPACK FOOTER //
// ./src/views/FileUploadInfo/container/FileUploadInfo.js